/**
 * Marker we put on errors after capturing them to Sentry from the upload hook,
 * so the global TanStack onError handler can skip them and avoid duplicate
 * Sentry events.
 *
 * Lives in a plain (non-`client-only`) module because it's read by
 * `capture-tanstack-error.ts`, which is shared between Server and Client
 * Components via the global TanStack `query-client`.
 */
export const DOCUMENT_UPLOAD_SENTRY_REPORTED = Symbol.for(
  'portal.document_upload.sentryReported'
);
